import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, TemplateRef } from '@angular/core';
import { SimInitialsPipe } from '@simOn/common/pipes';
import { avatarColor, UserStatus } from '@simOn/common/user-info-card-models';
import { EllipsisTooltipDirective } from '@simOn/ui/sim-tooltip';

@Component({
  selector: 'user-info',
  imports: [SimInitialsPipe, NgTemplateOutlet, EllipsisTooltipDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./sim-user-info.component.scss'],
  template: `
    <div class="user-info">
      <div class="user-info__initials" [style.background-color]="resolvedCircleColor()">
        <div>{{ userName() | initials }}</div>
      </div>
      <div class="user-info__content">
        <div class="user-info__content--name" simEllipsisTooltip data-cy="user-info-name">{{ userName() }}</div>
        <div class="user-info__content--email" simEllipsisTooltip data-cy="user-info-email">{{ userEmail() }}</div>
        @if (userInfo(); as info) {
          <div class="user-info__content--info">
            <ng-container *ngTemplateOutlet="info" />
          </div>
        }
      </div>
    </div>
  `
})
export class SimUserInfoComponent {
  readonly userName = input.required<string>();
  readonly userEmail = input('');
  /** When set, the avatar color is derived from this id via the shared `avatarColor` palette. */
  readonly userId = input('');
  /** Inactive statuses gray out the avatar color derived from `userId`. */
  readonly userStatus = input<UserStatus | undefined>(undefined);
  readonly userInfo = input<TemplateRef<unknown> | undefined>(undefined);
  /** Overrides the color derived from `userId`. */
  readonly circleColor = input<string | undefined>(undefined);

  protected readonly resolvedCircleColor = computed(
    () => this.circleColor() ?? (this.userId() ? avatarColor(this.userId(), this.userStatus()) : undefined)
  );
}
